module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-presents-money-c935b55664ce02096da3e192dd6b49b8.svg";